'use strict';

const jQuery = require('jquery');
const uniqId = require('uniq-id');
const _ = require('lodash');

const Translator = require('./../../core/translator');

const fb = require('./builder');

module.exports = function(config) {
  if (undefined === config) {
    throw new Error('Config for element must be set');
  }

  let element = this;

  this.id = '_' + uniqId(null, 5);
  this.name = config.name;
  this.form = config.form;
  this.placeholder = Translator.translate(config.placeholder);
  this.value = config.value;
  this.label = Translator.translate(config.label);
  this.disabled = config.disabled || false;
  this.error = config.error || null;
  this.type = config.type;
  this.question = config.question || null;
  this.config = config;

  if (_.isString(this.value)) {
    this.value = Translator.translate(this.value);
  }

  this.displayError = function(error) {
    error = error || element.error;
    if (!error) {
      return;
    }

    let span = element.$.find('span.error');
    if (span.length === 0) {
      span = jQuery('<span class="error"></span>');
      element.$.append(span);
    }

    span.removeClass('d-none');
    span.text(error);
  };

  this.hideError = function() {
    let span = element.$.find('span.error');

    if (span.length > 0) {
      span.addClass('d-none');
      span.text('');
    }
  };

  this.getDefaultElementClass = function(classParam) {
    let defaultConfig = fb.getDefaultConfig();

    if (defaultConfig &&
      defaultConfig.elements &&
      defaultConfig.elements[config.type] &&
      defaultConfig.elements[config.type][classParam]) {
      return defaultConfig.elements[config.type][classParam];
    }

    return '';
  };

  this.setDefaultClass = function() {
    element.wrapClass = config.wrap_class || element.getDefaultElementClass('wrap_class');
    element.elementClass = config.element_class || element.getDefaultElementClass('element_class');
    element.labelClass = config.label_class || element.getDefaultElementClass('label_class');
  };

  (function() {
    element.setDefaultClass();
  }());

  return this;
};
